<template>

  <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form @submit.stop.prevent="handleSubmit(guardar)">
      <b-container fluid>
        <b-row>
          <b-col cols="12">
            <label>Nombre del odóntologo interconsultante:
            </label>
            <b-list-group-item >{{ datosFormulario.nombreEmpleadoConsulta }}</b-list-group-item>
          </b-col>
          <b-col cols="12">
            <label> Odontólogo
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.nombreEmpleadoResponde }}</b-list-group-item>

            <b-form-group v-else>
              <b-input-group>
                <template v-slot:append>
                  <b-button v-if="mostrarBusquedaDoctor" variant="outline-primary"
                            @click="llenarListaDoctores">
                    <b-icon class="searchicon" icon="search"></b-icon>
                  </b-button>
                  <b-button v-if="!mostrarBusquedaDoctor" variant="outline-warning"
                            :disabled="secondReagendar"
                            @click="limpiarDoctorSeleccionado">
                    <b-icon icon="trash-fill"></b-icon>
                  </b-button>
                </template>
                <b-form-input v-if="mostrarBusquedaDoctor"
                              v-model="datosFormulario.nombreDoctorBusqueda"
                              placeholder="Ingresa un nombre" type="text"
                              v-on:keypress="esLetra($event)"
                              @keydown.enter.prevent="llenarListaDoctores"></b-form-input>

                <b-form-input v-if="!mostrarBusquedaDoctor" disabled required
                              v-model="datosFormulario.nombreEmpleadoResponde"
                              placeholder="Selecciona un paciente de los resultados" type="text"
                              v-on:keypress="esLetra($event)"></b-form-input>
              </b-input-group>

              <b-container class="bv-example-row">
                <b-row>
                  <b-col></b-col>
                  <b-col cols="10">
                                    <span v-if="mostrarBusquedaDoctor && leyendaSinDatos">
                                      No hay coincidencias con tu búsqueda
                                    </span>
                                    <span class="tablePatients"
                                          v-if="mostrarBusquedaDoctor && listaDoctores.length > 0" column="3">
                                        <div class="mt-2 col-md-12"></div>
                                        <b-table thead-tr-class="columnas" :items="listaDoctores"
                                                 :fields="encabezadosSeleccionDoctor"
                                                 :per-page="$registrosPorPaginaTabla" :current-page="paginaActual"
                                                 :hover="true" :small="true" @row-clicked="setearDoctor"
                                                 class="parrafos" responsive fixed>
                                            <template v-slot:cell(id)="row">
                                                <span>{{ row.item.idEmpleado }}</span>
                                            </template>
                                            <template v-slot:cell(name)="row">
                                                <div class="spanCien">
                                                    <span>
                                                        {{ row.item.nombre }}
                                                    </span>
                                                </div>
                                            </template>
                                        </b-table>
                                        <b-pagination v-if="listaDoctores.length > 15" align="center"
                                                      v-model="paginaActual" :total-rows="listaDoctores.length"
                                                      :per-page="$registrosPorPaginaTabla"></b-pagination>
                                    </span>
                  </b-col>
                </b-row>
              </b-container>

            </b-form-group>
          </b-col>
          <b-col cols="12">
            <label>Tipo de interconsulta
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.nombreTipoInterConsulta }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <v-select
                  :options="listaTiposInterConsulta"
                  class="parrafos"
                  id="idTipoInterConsulta"
                  label="nombre"
                  :reduce="(val) => val.idTipoInterConsulta"
                  placeholder="Seleccionar tipo de interconsulta"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.idTipoInterConsulta"></v-select>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <label>Motivo de interconsulta
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.motivoConsulta }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-input
                  placeholder="Coloque el motivo de interconsulta"
                  id="motivoConsulta"
                  class="motivoConsulta"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.motivoConsulta">
              </b-form-input>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <label> Procedimiento Actual
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.procedimiento }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-textarea
                  id="procedimiento"
                  placeholder="Describa el procedimiento actual..."
                  rows="3"
                  max-rows="6"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.procedimiento"
              ></b-form-textarea>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <label> Evolución
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.evolucion }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-textarea
                  id="evolucion"
                  placeholder="¿Hay evolución?"
                  rows="3"
                  max-rows="6"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.evolucion"></b-form-textarea>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <label>¿Se cuenta con hx relacionadas en el ECE?
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.estudiosRadiograficos === undefined || datosFormulario.estudiosRadiograficos === null || datosFormulario.estudiosRadiograficos === false ? 'NO' : 'SI' }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-radio-group
                  id="radio-slots"
                  :options="options"
                  name="radio-inline"
                  v-model="datosFormulario.estudiosRadiograficos"
              ></b-form-radio-group>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <div v-if="datosFormulario.estudiosRadiograficos">
              <label>Especificar hx a consultar
                <validacion v-if="!desactivarCamposRegistroNuevo"/>
                <span v-else>:</span>
              </label>
              <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.estudiosRequeridos }}</b-list-group-item>
              <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
                <b-form-input
                    placeholder="Especificar que estudios radiográficos se requieren"
                    style="border: #0e6ba9 2px solid;"
                    v-model="datosFormulario.estudiosRequeridos"></b-form-input>
                <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12">
            <label>Diágnostico de ingreso
              <validacion v-if="!desactivarCamposRegistroNuevo"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRegistroNuevo">{{ datosFormulario.diagnosticoIngreso }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-input
                  placeholder="Describa el diágnostico de ingreso..."
                  id="diagnostico"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.diagnosticoIngreso"
              ></b-form-input>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row v-if="esConsulta || !desactivarCamposRespuesta">
          <b-col cols="12">
            <div style="text-align: center">
              <strong style="font-size:12px"> Espacio para respuesta del odontólogo interconsultante</strong>
            </div>
          </b-col>
          <b-col cols="12">
            <label> Respuesta de la interconsulta
              <validacion v-if="!desactivarCamposRespuesta"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRespuesta">{{ datosFormulario.respuestaInterconsulta }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-textarea
                  id="respuesta"
                  placeholder="¿Cuás es la respuesta de la interconsulta? "
                  rows="3"
                  max-rows="6"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.respuestaInterconsulta"
              ></b-form-textarea>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <label> Diágnostico
              <validacion v-if="!desactivarCamposRespuesta"/>
              <span v-else>:</span>
            </label>
            <b-list-group-item v-if="desactivarCamposRespuesta">{{ datosFormulario.diagnosticoRespuesta }}</b-list-group-item>
            <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
              <b-form-textarea
                  id="diagnostico2"
                  placeholder="Describa el diágnostico"
                  rows="3"
                  max-rows="6"
                  style="border: #0e6ba9 2px solid;"
                  v-model="datosFormulario.diagnosticoRespuesta"
              ></b-form-textarea>
              <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
            </validation-provider>
          </b-col>
          <b-col cols="12">
            <div class="row">
              <div class="col-md-4">
                <label>Tratamiento a seguir
                  <validacion v-if="!desactivarCamposRespuesta"/>
                  <span v-else>:</span>
                </label>
              </div>
              <span v-if="desactivarCamposRespuesta">
                  <b-list-group>
                    <b-list-group-item v-for="trat in datosFormulario.tratamientos" :key="trat.idTratamiento">{{trat.nombre}}</b-list-group-item>
                  </b-list-group>
              </span>
              <validation-provider :rules="{ required: true }" v-slot="errors" v-else>
                <b-form-group style="width: 100%">
                  <v-select
                      :options="listaTratamientos"
                      class="parrafos"
                      id="idTratamiento"
                      label="nombre"
                      placeholder="Seleccionar tratamientos"
                      multiple
                      style="border: #0e6ba9 2px solid;width: 100%"
                      v-model="datosFormulario.tratamientos"></v-select>
                </b-form-group>
                <validacion :texto="errors.errors[0] ? errors.errors[0] : ' '"/>
              </validation-provider>
            </div>
          </b-col>
          <b-col cols="12">
            <label> Observaciones</label>
            <b-list-group-item v-if="desactivarCamposRespuesta">{{ datosFormulario.observaciones }}</b-list-group-item>
            <b-form-textarea v-else
                             id="observaciones"
                             placeholder="Si existen observaciones, favor de comentarlas en este espacio"
                             rows="3"
                             max-rows="6"
                             style="border: #0e6ba9 2px solid;"
                             v-model="datosFormulario.observaciones"
            ></b-form-textarea>
          </b-col>

        </b-row>

      </b-container>

      <b-button id="submitGuardar"
                ref="submitGuardar" type="submit"
                style="visibility: hidden"
      ></b-button>
    </b-form>
  </validation-observer>

</template>

<script>
export default {
  name: "InterconsultaFormulario",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    listaTiposInterConsulta:[],
    listaDoctores: [],
    options: [
      {text: 'Si', value: 'true'},
      {text: 'No', value: 'false'}
    ],
    listaTratamientos: [],
    leyendaSinDatos: false,
    datosFormulario: {
      idInterconsulta: null,
      idPaciente: null,
      idClinica: null,
      nombreClinica: null,
      idEmpleadoConsulta: null,
      idEmpleadoResponde: null,
      nombreEmpleadoConsulta: null,
      nombreEmpleadoResponde: null,
      nombreDoctorBusqueda: null,
      motivoConsulta: null,
      procedimiento: null,
      diagnosticoIngreso: null,
      observaciones: null,
      estudiosRadiograficos: false,
      evolucion: null,
      estudiosRequeridos: null,
      diagnosticoRespuesta: null,
      respuestaInterconsulta: null,
      tratamientos: null
    },

    paginaActual: 1,
    secondReagendar: false,
    encabezadosSeleccionDoctor: [{
      key: "id",
      label: "Id"
    },
      {
        key: "name",
        label: "Nombre del Paciente"
      },
    ],


  }),
  async created() {
    this.debug = this.$localStorageService.getDebug();
    if (this.esRegistroNuevo) {
      this.datosFormulario.nombreEmpleadoConsulta = this.nombreUsuarioRegistro;
      this.datosFormulario.idEmpleadoConsulta = this.idEmpleadoRegistro;
      this.datosFormulario.idClinica = this.idClinicaRegistro;
      this.datosFormulario.idPaciente = this.idPacienteRegistro;
    }

    if (this.itemEdit !== undefined && this.itemEdit !== null) {
      this.datosFormulario = this.itemEdit;
    }

    await this.obtenerTipoInterConsulta()
    await this.llenarListaDoctores();
    await this.listarTratamientos();
  },
  props: {
    nombreUsuarioRegistro: String,
    idEmpleadoRegistro: Number,
    idClinicaRegistro: Number,
    idPacienteRegistro: Number,

    esRegistroNuevo: Boolean,
    esRespuesta: Boolean,
    esConsulta: Boolean,

    itemEdit: Object
  },
  computed: {
    desactivarCamposRegistroNuevo() {
      return this.esConsulta || this.esRespuesta || (this.esRegistroNuevo === undefined || this.esRegistroNuevo === null || !this.esRegistroNuevo)
    },
    desactivarCamposRespuesta() {
      return this.esConsulta || this.esRegistroNuevo || (this.esRespuesta === undefined || this.esRespuesta === null || !this.esRespuesta)
    },
    mostrarBusquedaDoctor: function () {
      return this.datosFormulario !== undefined
          && (this.datosFormulario.idEmpleadoResponde === undefined || this.datosFormulario.idEmpleadoResponde < 1);
    }
  },
  methods: {
    guardar() {
      let esNuevo = true;
      if (this.datosFormulario.idInterconsulta !== undefined
          && this.datosFormulario.idInterconsulta !== null && this.datosFormulario.idInterconsulta > 0) {
        esNuevo = false;
      }

      let apiGuardar = "interconsulta/guardarNuevaInterconsulta";
      if (!esNuevo) {
        apiGuardar = "interconsulta/guardarRespuestaInterconsulta";
      }


      if (this.datosFormulario.idEmpleadoResponde === undefined || this.datosFormulario.idEmpleadoResponde == null
          || this.datosFormulario.idEmpleadoResponde === 0) {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Debes buscar y seleccionar a quien solicitas la interconsulta",
        });
        return;
      }

      const objetoGuardar = JSON.parse(JSON.stringify(this.datosFormulario));

      this.$emit("actualizarLoadingGuardar", true);
      this.$http.post(this.$api + apiGuardar, objetoGuardar)
          .then(response => {
            if (response.status === 200) {
              this.$swal.fire({
                icon: 'success',
                title: 'La interconsulta se registró con éxito'
              });

              if (esNuevo) {
                this.$emit("mostrarModalRegistrar", false);
              } else {
                this.$emit("mostrarModalContestar", false);
              }

            }
          }).catch(error => {
            console.error(error);
            if (error.response) {

              let mensaje = error.response.data.message;

              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: mensaje,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente",
              });
            }
          }).finally(() => this.$emit("actualizarLoadingGuardar", false));

    },
    async obtenerTipoInterConsulta() {
      this.$http.get(this.$api + "interconsulta/obtenerTiposInterConsulta")
          .then(response => {
            this.listaTiposInterConsulta = response.data.data;
          });
    },
    async llenarListaDoctores() {
      this.listaDoctores = Array();
      this.paginaActual = 1;
      if (this.datosFormulario === undefined || this.datosFormulario.nombreDoctorBusqueda === undefined
          || this.datosFormulario.nombreDoctorBusqueda === null
          || this.datosFormulario.nombreDoctorBusqueda.length < 4) {
        return;
      }

      const inputTxt = this.datosFormulario.nombreDoctorBusqueda
          .trim()
          .toLowerCase()
          .toUpperCase();

      this.leyendaSinDatos = false;

      const params = {
        idClinica: this.idClinicaRegistro,
        nombreEmpleado: inputTxt,
      }
      this.$http.post(this.$api + "colaboradores/obtenerDiagnosticadoresEspecialistasClinica", params)
          .then(response => {
            this.listaDoctores = Array.from(
                new Set(response.data.data.map(a => a.idEmpleado))
            ).map(id => {
              return response.data.data.find(a => a.idEmpleado === id);
            });
            if (Array.isArray(this.listaDoctores)) {
              this.listaDoctores.sort(function (a, b) {
                if (a.idEmpleado > b.idEmpleado) {
                  return 1;
                }
                if (a.idEmpleado < b.idEmpleado) {
                  return -1;
                }
                return 0;
              });
            }
          }).finally(()=>this.leyendaSinDatos = (this.listaDoctores.length <= 0))
    },
    async listarTratamientos() {
      this.$http.get(this.$api + "tratamientos/obtener/tx").then((response) => {
        if (response.data.data) {
          const aux = response.data.data
          aux.forEach(t => {
            this.listaTratamientos.push({
              idTratamiento: t.idTratamiento,
              nombre: t.nombre,
            })
          })
        }
      })
    },

    limpiarDoctorSeleccionado() {
      this.datosFormulario.idEmpleadoResponde = null;
      this.datosFormulario.nombreEmpleadoResponde = null;
      this.listaDoctores = Array();
    },
    setearDoctor(item) { //item, index, event
      this.datosFormulario.idEmpleadoResponde = item.idEmpleado;
      this.datosFormulario.nombreEmpleadoResponde = item.nombre;
      window.scrollTo(0, 0);
    },
    esLetra(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ\s]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
  }
}
</script>

<style scoped>


</style>
